<template lang="">
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        Loading...
    </div>
        <div class="container-fluid py-3">
            <div class="box top-box mb-15 p-3 rounded-3 bg-white d-flex align-items-center shadow">
            <h4 class="font-weight-bold">PO 발행 페이지</h4>
            </div>
            
            <v-card class="pa-4" elevation="2">
                <div class="d-flex align-items-center mb-3">
                    <span class="ml-2 mr-6 font-weight-bold">회사 검색 :  </span> 
                    <v-text-field 
                        v-model="search" 
                        class="mr-3 search-field custom-width custom-bg" 
                        outlined 
                        dense 
                        variant="outlined">
                    </v-text-field>
                    
                    <v-btn color="primary" class="ml-auto" @click="addItem">새로운 PO 신청</v-btn>
                </div>

                <v-data-table 
                    :headers="headers" 
                    :items="filteredItems" 
                    class="elevation-1" 
                    density = "compact">
                </v-data-table>
            </v-card>

        </div>
</template>
<script>

export default {

    data() {
        return {
        search: "",
        headers: [
            { title: "회사 코드", key: "companyCode", align: "center", sortable: true },
            { title: "회사 이름", key: "companyName", align: "center", sortable: true }, // 추가된 컬럼
            { title: "PO NO#", key: "poNumber", align: "center", sortable: false },
            { title: "PO QTY", key: "poQty", align: "center", sortable: false },
            { title: "SHIPPED QTY", key: "shippedQty", align: "center", sortable: false },
            { title: "RECEIVED QTY", key: "receivedQty", align: "center", sortable: false },
            { title: "상태", key: "status", align: "center", sortable: true }, // 추가된 컬럼
        ],
        items: [
            { companyCode: "P0100", companyName: "ABC Corp", poNumber: "202401-001", poQty: "200,250", shippedQty: "1,000", receivedQty: "100,000", status: "진행 중" },
            { companyCode: "P0200", companyName: "XYZ Ltd", poNumber: "202401-002", poQty: "100,000", shippedQty: "25,000", receivedQty: "50,000", status: "완료" },
            { companyCode: "P0200", companyName: "LMN Inc", poNumber: "2024-01-03", poQty: "200,000", shippedQty: "0", receivedQty: "200,000", status: "대기" },
        ],
        };
    },
    computed: {
        filteredItems() {
        return this.items.filter(item => 
            item.companyCode.toLowerCase().includes(this.search.toLowerCase())
        );
        }
    },
    methods: {
        addItem() {
        //console.log("새 항목 추가 기능 구현 필요");
        }
    }
}
</script>
<style scoped>
.custom-width {
    max-width: 300px; /* 원하는 크기로 변경 가능 */
}

/* 배경색 적용 */
.custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
}

.custom-min-height {
    min-height: 400px;
}

.vertical-align {
    vertical-align: middle;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 9999;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    z-index: 9999;
    animation: spin 1s linear infinite;
}

.data-table-row:hover {
    background-color: #f5f5f5;
    /* 마우스 오버 시 배경색 변경 */
    cursor: pointer;
}

:deep() .v-table .v-table__wrapper > table > thead > tr > th {
        border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
    }
    :deep() .v-table .v-table__wrapper > table > tbody > tr > td {
        border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
    }
</style>